import { useState } from "react";
import { faqs } from "@/mocks/blog";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50">
      <div className="mx-auto w-full max-w-3xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">FAQ</p>
          <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
            常见问题 · <span className="text-primary-600">你可能想问的</span>
          </h2>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f, idx) => {
            const open = openIdx === idx;
            return (
              <div key={idx} className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
                <button
                  onClick={() => setOpenIdx(open ? -1 : idx)}
                  className="flex w-full cursor-pointer items-center gap-3 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-bold ${
                      open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    ?
                  </span>
                  <span className="flex-1 font-display text-[15px] font-semibold text-foreground-900 md:text-base">
                    {f.q}
                  </span>
                  <i
                    className={`${open ? "ri-subtract-line" : "ri-add-line"} text-xl text-foreground-500 transition-transform`}
                    aria-hidden="true"
                  ></i>
                </button>
                {open && (
                  <div className="px-5 pb-5 pl-[52px]">
                    <p className="text-sm leading-[1.9] text-foreground-600 md:text-[15px]">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </section>
  );
}